<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="halftitlepage" id="bkht">
<p class="sert" style="text-align:center;"><span aria-label="i" class="page" id="pi" role="doc-pagebreak"></span>The Collected Works of F. A. Hayek</p>
<p class="sers" style="text-align:center;">Volume XIX</p>
<h1 class="bkht">Law, Legislation, and Liberty</h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hayek-vol19-0002.vue?3e82be0c